import { render, staticRenderFns } from "./CardLoading.vue?vue&type=template&id=5ec4117d&scoped=true&"
import script from "./CardLoading.vue?vue&type=script&lang=js&"
export * from "./CardLoading.vue?vue&type=script&lang=js&"
import style0 from "./CardLoading.scss?vue&type=style&index=0&id=5ec4117d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4117d",
  null
  
)

export default component.exports